import { render, staticRenderFns } from "./ingredient.vue?vue&type=template&id=30c1af92&"
import script from "./ingredient.vue?vue&type=script&lang=js&"
export * from "./ingredient.vue?vue&type=script&lang=js&"
import style0 from "./ingredient.vue?vue&type=style&index=0&id=30c1af92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports